import { encodeArrowSync } from "./lib/encode-arrow.js";
const VERSION = typeof "4.1.0-alpha.9" !== 'undefined' ? "4.1.0-alpha.9" : 'latest';
export const ArrowWriter = {
  name: 'Apache Arrow',
  id: 'arrow',
  module: 'arrow',
  version: VERSION,
  extensions: ['arrow', 'feather'],
  mimeTypes: ['application/vnd.apache.arrow.file', 'application/vnd.apache.arrow.stream', 'application/octet-stream'],
  binary: true,
  options: {},
  encode: async function encodeArrow(data, options) {
    return encodeArrowSync(data);
  },
  encodeSync(data, options) {
    return encodeArrowSync(data);
  }
};
//# sourceMappingURL=arrow-writer.js.map